function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import Icon from "./Icon";
import "./Animicon.css";
export default class Animicon extends Component {
  render() {
    const {
      isIn,
      name,
      ...rest
    } = this.props;
    const classes = classnames(`ax-animicon--${name}`, {
      [`ax-animicon--${name}-in`]: isIn
    });
    return /*#__PURE__*/React.createElement(Icon, _extends({}, rest, {
      className: classes,
      name: name
    }));
  }
}